import { render, staticRenderFns } from "./FeedbackUdi.vue?vue&type=template&id=99d50508&"
import script from "./FeedbackUdi.vue?vue&type=script&lang=js&"
export * from "./FeedbackUdi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports